import _ from 'lodash'
import React from 'react'

export const mapAddressParser = (address) => ({
  ...address,
  id: address.municipality_id,
  name: address.municipality_name
})

export const excludePrefecture = (prefecture) => {
  // 県ID以外の値を排除
  // 99: 海外 100: 未入力
  let list = [99,100]
  return list.indexOf(prefecture.id) < 0
}

export const convertLineBreaksToHtml = (str) => {
  if(!str) {
    return
  }
  const escapeHtmlTable = {
    '&': '&amp;',
    '\'': '&#39;',
    '"': '&quot;',
    '<': '&lt;',
    '>': '&gt;',
  }
  str = str.replace(/[&"'<>]/g, match => escapeHtmlTable[match])
    .replace(/(?:\r\n|\r|\n)/g, '<br />')
  return str
}

export const nl2br = (str) => {
  if (!str) return
  return str.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)
}

export const convertPlainUrlToATag = (str) => {
  return str ? str.replace(/((http|https|ftp):\/\/[\w?=&.-;#~%-]+(?![\w\s?&.;#~%"=-]*>))/g, '<a href="$1" target="_blank" rel="noopener">$1</a>') : ""
}

export const getActiveItemFromId = (items, id, propName) => {
  items = items.filter(item => item.id === id)

  if (propName) {
    return (items[0] && items[0][propName]) ? items[0][propName] : ''
  }

  return items[0] ? items[0] : {}
}

export const genders = [
  {
    id: 'male',
    name: '男性'
  },
  {
    id: 'female',
    name: '女性'
  },
  {
    id: 'unknown',
    name: 'unknown'
  }
]

export const patientType = [
  {
    id: 'myself',
    name: '本人'
  },
  {
    id: 'relative',
    name: '家族'
  },
  {
  id: 'friend',
  name: '友達'
  }
]

export const patientStatus = {
  pending: 'pending',
  cleaned: 'ready',
  confirming: 'confirming',
  open: 'publish',
  done: 'done',
}
export const getPatientStatus = (status) => {
  return patientStatus[status]
}

export const getGenderName = (id) => {
  return getActiveItemFromId(genders, id, 'name')
}

export const getPatientTypeName = (id) => {
  return getActiveItemFromId(patientType, id, 'name')
}

export const allowedFileExtensions = ['png', 'jpg', 'jpeg', 'zip', 'pdf']

export const isAllowedFileExtension = (fileName) => {
  let fileExtension = fileName.split('.').pop()
  fileExtension = _.toLower(fileExtension)
  return allowedFileExtensions.indexOf(fileExtension) > -1
}

export function getDataType(fileName) {
  let fileType
  let imageExtensions = ['png', 'jpg', 'gif', 'jpeg', 'bmp']
  let fileExtension = _.toLower(fileName.split('.').pop())
  if(imageExtensions.indexOf(fileExtension) !== -1) {
    fileType = 'image'
  } else if (fileExtension === 'pdf') {
    fileType = 'pdf'
  } else {
    fileType = 'file'
  }
  return fileType
}
export function checkCancer(str) {
  return /(がん|ガン|癌)/.test(str)
}

export const setDefault = (targetObject, defaultObject) => {
  const target = { ...targetObject }

  Object.keys(defaultObject).forEach(key => {
    if (target[key] === null || target[key] === undefined) {
      target[key] = defaultObject[key]
    } else if (typeof (target[key]) === 'object' && !(target[key] instanceof Array)) {
      target[key] = setDefault(target[key], defaultObject[key])
    }
  })

  return target
}

export const japanCurrency = (num) => {
  return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

export const makeBudgetsArray = (min, max, step) => {
  let options = []

  do {
    options = [
      ...options,
      {
        id: String(min),
        name: `${japanCurrency(min)}円`
      }
    ]

    min += step
  } while (min <= max)

  return options
}

export const formatBytes = (bytes,decimals) => {
  if (bytes === 0) return '0 bytes'
  var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const formatName = (key, campaign) => {
  let serviceNames = {
    findme: {
      main: 'Findme',
      FWD: 'Findme F'
    },
    report: {
      main: 'セカンドオピニオンレター',
      FWD: 'レポート'
    },
  }
  let name = serviceNames[key][campaign]
  return name ? name : serviceNames[key]['main'];
}


// WEBPACK FOOTER //
// ./src/modules/formatting.js